{
  "tabs": {
    "chat": "چيٽ",
    "reminders": "ياد ڏياريندڙ",
    "calendar": "ڪئلينڊر",
    "settings": "سيٽنگون"
  },
  "common": {
    "cancel": "منسوخ ڪريو",
    "save": "محفوظ ڪريو",
    "confirm": "پڪ ڪريو",
    "delete": "حذف ڪريو",
    "back": "واپس",
    "close": "بند ڪريو",
    "edit": "ترميم ڪريو",
    "search": "ڳولا",
    "all": "سڀ",
    "loading": "لوڊ ٿي رهيو آهي...",
    "error": "ڪجهه غلط ٿي ويو",
    "notFound": "نه مليو",
    "tryAgain": "مهرباني ڪري ٻيهر ڪوشش ڪريو",
    "retry": "ٻيهر ڪوشش ڪريو",
    "undo": "واپس ڪريو",
    "pullToRefresh": "تازه ڪاري لاءِ ڇڪيو",
    "justNow": "هاڻي ئي"
  },
  "auth": {
    "welcome": "FishMemory ۾ ڀليڪار",
    "tagline": "توهان جو WhatsApp ياد ڏياريندڙ مددگار، هاڻي توهان جي جیب ۾.",
    "subtitle": "توهان جو WhatsApp ياد ڏياريندڙ مددگار، هاڻي توهان جي جیب ۾.",
    "phoneLabel": "توهان جو WhatsApp نمبر",
    "phoneHint": "اسان WhatsApp ذريعي تصديق ڪوڊ موڪلينداسين",
    "invalidPhone": "مهرباني ڪري صحيح فون نمبر داخل ڪريو",
    "continue": "جاري رکو",
    "enterPhone": "پنهنجو WhatsApp نمبر داخل ڪريو",
    "phonePlaceholder": "فون نمبر",
    "sendCode": "ڪوڊ موڪليو",
    "verifyTitle": "پنهنجو نمبر تصديق ڪريو",
    "otpSentTo": "6-عددي ڪوڊ {{phone}} تي WhatsApp ذريعي موڪليو ويو",
    "enterFullCode": "مهرباني ڪري سڀ 6 عدد داخل ڪريو",
    "invalidOtp": "غلط ڪوڊ. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
    "otpFailed": "ڪوڊ موڪلڻ ۾ ناڪامي. ٻيهر ڪوشش ڪريو.",
    "otpResent": "ڪوڊ ٻيهر موڪليو ويو",
    "resendIn": "{{seconds}} سيڪنڊن ۾ ٻيهر موڪليو",
    "resendCode": "ڪوڊ ٻيهر موڪليو",
    "enterOtp": "WhatsApp تي موڪليل ڪوڊ داخل ڪريو",
    "verify": "تصديق ڪريو",
    "resend": "ڪوڊ ٻيهر موڪليو",
    "wrongNumber": "غلط نمبر؟",
    "backToPhone": "فون ڏانهن واپس",
    "editPhone": "فون نمبر ترميم ڪريو",
    "error": "غلطي",
    "setupTitle": "چلو ترتيب ڏيون",
    "setupSubtitle": "توهان هميشه سيٽنگن ۾ تبديل ڪري سگهو ٿا",
    "namePlaceholder": "توهان جو نالو",
    "letsGo": "ترتيب مڪمل ڪريو",
    "skipForNow": "هاڻي ڇڏي ڏيو"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "هڪ پيغام لکو...",
    "inputPlaceholder": "هڪ پيغام لکو...",
    "typing": "FishMemory لکي رهيو آهي...",
    "online": "آن لائن",
    "connecting": "جڙڻ...",
    "reconnecting": "ٻيهر جڙڻ...",
    "offline": "آف لائن",
    "empty": "گفتگو شروع ڪريو",
    "emptyHint": "ياد ڏياريندڙ ٺاهيو، پنهنجو شيڊول ڏسو، يا مدد لاءِ پڇو.",
    "emptyAction": "نمونو ياد ڏياريندڙ موڪليو",
    "actions": "چيٽ عمل",
    "keep": "پيغام رکڻ",
    "clearTitle": "چيٽ صاف ڪريو",
    "clearConfirm": "ڇا توهان هن ڊوائيس تان سڀ پيغام حذف ڪرڻ چاهيو ٿا؟ هي واپس نٿو ڪري سگهجي.",
    "clear": "چيٽ صاف ڪريو",
    "optionSelected": "منتخب ٿيل: {{label}}",
    "sendingSelection": "موڪلي رهيو آهي...",
    "connectionLost": "ٻيهر جڙڻ..."
  },
  "reminders": {
    "title": "منهنجا ياد ڏياريندڙ",
    "active": "فعال",
    "today": "اڄ",
    "thisWeek": "هن هفتي",
    "history": "تاريخ",
    "items": "شيون",
    "emptyTitle": "هن وقت ڪو ياد ڏياريندڙ ناهي",
    "emptySubtitle": "چيٽ مان هڪ ٺاهيو ۽ هتي ڏيکاريو ويندو.",
    "emptyAction": "چيٽ کوليو",
    "filterActive": "فعال",
    "filterToday": "اڄ",
    "filterWeek": "هن هفتي",
    "filterHistory": "تاريخ",
    "emptyState": "هن وقت ڪو ياد ڏياريندڙ ناهي. چيٽ شروع ڪريو!",
    "swipeDone": "مڪمل",
    "swipeSnooze": "سنوذ",
    "swipeDelete": "حذف ڪريو",
    "search": "ياد ڏياريندڙ ڳوليو...",
    "upcoming": "اڳتي",
    "completed": "مڪمل ٿيل",
    "overdue": "دير ٿيل",
    "tomorrow": "سڀاڻي",
    "synced": "هم وقت ٿيل {{value}}",
    "swipeHint": "وڌيڪ عمل لاءِ ياد ڏياريندڙ کي سوائپ ڪريو",
    "noResults": "توهان جي ڳولا سان ڪو ياد ڏياريندڙ نه مليو",
    "noResultsHint": "مختلف لفظ آزمائي ڏسو يا ڳولا صاف ڪريو",
    "deleteAllFailed": "سڀ ياد ڏياريندڙ حذف ڪرڻ ۾ ناڪامي"
  },
  "calendar": {
    "title": "ڪئلينڊر",
    "today": "اڄ",
    "tomorrow": "سڀاڻي",
    "completed": "مڪمل",
    "noEvents": "ڪجهه به مقرر ناهي",
    "noEventsSubtitle": "ياد ڏياريندڙ ۽ ڪئلينڊر واقعا ڏسڻ لاءِ تاريخ چونڊيو.",
    "googleEvent": "Google ڪئلينڊر",
    "legendActive": "فعال",
    "legendRecurring": "دهرائيندڙ",
    "legendDone": "مڪمل",
    "legendGoogle": "Google",
    "previousMonth": "گذريل مهينو",
    "nextMonth": "اڳيون مهينو",
    "previousYear": "گذريل سال",
    "nextYear": "اڳيون سال",
    "goToToday": "اڄ ڏانهن وڃو",
    "all": "سڀ",
    "active": "فعال",
    "done": "مڪمل",
    "paused": "وقف ٿيل"
  },
  "settings": {
    "title": "سيٽنگون",
    "profile": "پروفائل",
    "name": "ظاهر ٿيندڙ نالو",
    "enterName": "پنهنجو نالو داخل ڪريو",
    "language": "ٻولي",
    "uiLanguage": "ايپ جي ٻولي",
    "uiLanguageHelp": "صرف هن ڊوائيس تي ايپ جو انٽرفيس، ڪئلينڊر ليبل ۽ ترتيب جي رخ کي تبديل ڪري ٿو.",
    "serverLanguage": "چيٽ ٻولي",
    "serverLanguageHelp": "توهان جي اڪائونٽ لاءِ سرور جوابن ۽ ياد ڏياريندڙ پيغامن ۾ استعمال ٿيندڙ ٻولي تبديل ڪري ٿو.",
    "timezone": "ٽائيم زون",
    "currentTimezone": "موجوده ٽائيم زون",
    "timezoneHelp": "سڀ ياد ڏياريندڙ وقت هن ٽائيم زون ۾ ڏيکاريا ويندا.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "ٽائيم زون محفوظ ڪريو",
    "timezoneSaved": "ٽائيم زون اپڊيٽ ٿي ويو",
    "detect": "سڃاڻپ ڪريو",
    "detectFailed": "ٽائيم زون سڃاڻڻ ۾ ناڪامي",
    "autoDetect": "GPS مان پاڻمرادو سڃاڻپ",
    "notifications": "اطلاعات",
    "notificationsHelp": "فالو اپ ياد ڏياريندڙ ياد ڏياريندڙ پهچائڻ کان پوءِ ورجندڙ خبردارين کي ڪنٽرول ڪن ٿا. ڊوائيس سطح جون اطلاعن جون اجازت اڃا به توهان جي فون جي سيٽنگن ۾ سنڀاليون وڃن ٿيون.",
    "pushEnabled": "پش اطلاعن کي فعال ڪريو",
    "autoDoneOnFire": "فائر ٿيڻ تي پاڻمرادو مڪمل نشان لڳايو",
    "autoDoneOnFireDesc": "جيڪڏهن بند هجي، ياد ڏياريندڙ فعال رهندا جيستائين توهان انهن کي مڪمل طور نشان لڳايو.",
    "googleCalendar": "Google ڪئلينڊر",
    "google": "Google ڪئلينڊر",
    "googleConnected": "جڙيل",
    "googleDisconnected": "نه جڙيل",
    "googleConnectedHelp": "نئون ياد ڏياريندڙ پاڻمرادو توهان جي ڪئلينڊر سان هم وقت ٿي سگهن ٿا.",
    "googleDisconnectedHelp": "Google ڪئلينڊر کي ڳنڍيو ته جيئن ياد ڏياريندڙ ۽ واقعا هم آهنگ رهن.",
    "googleConnectFailed": "Google ڪئلينڊر سان ڳنڍڻ ۾ ناڪامي",
    "connected": "جڙيل",
    "disconnected": "نه جڙيل",
    "connect": "ڳنڍيو",
    "disconnect": "الڳ ڪريو",
    "autoSync": "نئين ياد ڏياريندڙن کي پاڻمرادو هم وقت ڪريو",
    "autosync": "نئين ياد ڏياريندڙن کي پاڻمرادو هم وقت ڪريو",
    "subscription": "رڪنيت",
    "trialUsed": "ٽرائل: {{used}}/{{total}} استعمال ٿيل",
    "trialStatus": "ٽرائل موجود",
    "activeStatus": "فعال رڪنيت",
    "expiredStatus": "رڪنيت ختم ٿي وئي",
    "unsubscribedStatus": "رڪنيت ناهي",
    "about": "بابت",
    "version": "نسخو",
    "logout": "لاگ آئوٽ",
    "logoutTitle": "لاگ آئوٽ",
    "logoutConfirm": "ڇا توهان واقعي لاگ آئوٽ ڪرڻ چاهيو ٿا؟",
    "noName": "ڪو نالو مقرر ناهي",
    "serverConnection": "سرور ڪنيڪشن",
    "serverUrl": "سرور URL",
    "serverEdit": "ترميم ڪريو",
    "saveReconnect": "محفوظ ڪريو ۽ ٻيهر ڳنڍيو",
    "resetDefault": "پهرين واري حالت تي آڻيو",
    "invalidServerUrlTitle": "غلط سرور URL",
    "invalidServerUrlMessage": "مهرباني ڪري صحيح http يا https سرور URL داخل ڪريو، جهڙوڪ https://example.com",
    "uiLanguageChangeFailed": "ايپ جي ٻولي تبديل ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
    "serverLanguageChangeFailed": "چيٽ ٻولي تبديل ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
    "timezoneChangeFailed": "ٽائيم زون تبديل ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
    "autoSyncChangeFailed": "پاڻمرادو هم وقت اپڊيٽ ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
    "nameChangeFailed": "ظاهر ٿيندڙ نالو اپڊيٽ ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "ياد ڏياريندڙ جا تفصيل",
    "editTime": "وقت ترميم ڪريو",
    "rename": "نالو تبديل ڪريو",
    "snooze": "سنوذ ڪريو",
    "snooze15": "15 منٽ لاءِ سنوذ ڪريو",
    "pause": "وقف ڪريو",
    "pauseReminder": "ياد ڏياريندڙ کي وقف ڪريو",
    "resume": "ٻيهر شروع ڪريو",
    "resumeReminder": "ياد ڏياريندڙ ٻيهر شروع ڪريو",
    "skip": "اڳيون ڇڏي ڏيو",
    "skipOccurrence": "هن واقع کي ڇڏي ڏيو",
    "syncGoogle": "Google سان هم وقت ڪريو",
    "delete": "حذف ڪريو",
    "deleteTitle": "ياد ڏياريندڙ حذف ڪريو",
    "deleteConfirm": "هي ياد ڏياريندڙ هميشه لاءِ حذف ٿي ويندو.",
    "deleteRecurringTitle": "دهرائيندڙ ياد ڏياريندڙ حذف ڪريو",
    "deleteRecurringMessage": "ڇا توهان هن واقع کي ڇڏي ڏيڻ چاهيو ٿا يا سڄي سيريز کي حذف ڪرڻ چاهيو ٿا؟",
    "deleteThisOccurrence": "هن واقع کي ڇڏي ڏيو",
    "deleteEntireSeries": "سڄي سيريز کي حذف ڪريو",
    "done": "مڪمل",
    "markDone": "مڪمل طور نشان لڳايو",
    "undo": "واپس ڪريو",
    "undoPrompt": "ڇا ٻيهر فعال ڪرڻو آهي؟ هاڻي واپس ڪريو.",
    "recurring": "دهرائيندڙ",
    "nextRun": "اڳيون هلڻ",
    "oneTime": "هڪ دفعو",
    "pending": "زير التوا",
    "sent": "موڪليو ويو",
    "paused": "وقف ٿيل",
    "active": "فعال",
    "snoozed": "سنوذ ٿيل",
    "localTime": "توهان جي مقامي وقت ۾ ڏيکاريل",
    "recurrence": "دهراءُ",
    "created": "تيار ڪيو ويو",
    "tags": "ٽيگ",
    "fireCount": "وار فائر ٿيل",
    "actions": "عمل",
    "none": "ڪوبه ناهي",
    "snoozeFailed": "ياد ڏياريندڙ سنوذ ڪرڻ ۾ ناڪامي",
    "pauseFailed": "ياد ڏياريندڙ کي وقف ڪرڻ ۾ ناڪامي",
    "resumeFailed": "ياد ڏياريندڙ ٻيهر شروع ڪرڻ ۾ ناڪامي",
    "skipFailed": "ياد ڏياريندڙ ڇڏي ڏيڻ ۾ ناڪامي",
    "doneFailed": "ياد ڏياريندڙ کي مڪمل طور نشان لڳائڻ ۾ ناڪامي",
    "undoFailed": "ياد ڏياريندڙ جي حالت واپس آڻڻ ۾ ناڪامي",
    "deleteFailed": "ياد ڏياريندڙ حذف ڪرڻ ۾ ناڪامي",
    "rescheduleTitle": "ٻيهر شيڊول ڪريو؟",
    "rescheduleMsg": "هي ياد ڏياريندڙ دير ٿي چڪو آهي. ڇا توهان ان کي ٻيهر شيڊول ڪرڻ چاهيو ٿا؟",
    "reschedule15": "15 منٽن ۾",
    "reschedule60": "1 ڪلاڪ ۾",
    "keepOverdue": "اصل حالت ۾ رکو"
  },
  "onboarding": {
    "slide1Title": "FishMemory ۾ ڀليڪار",
    "slide1Sub": "توهان جو ذاتي ياد ڏياريندڙ مددگار — WhatsApp ذريعي ۽ توهان جي جیب لاءِ ٺهيل.",
    "slide2Title": "فطري طور چيٽ ڪريو",
    "slide2Sub": "ياد ڏياريندڙ اهڙي طرح لکو جيئن توهان سوچيو ٿا: \"مون کي سڀاڻي 3 وڳي ماءُ کي فون ڪرڻ ياد ڏيار\" — اسان باقي سنڀالينداسين.",
    "slide3Title": "ڪڏهن به ڪجھ نه وساريو",
    "slide3Sub": "وقت سر اطلاعون حاصل ڪريو، ٽيگ سان منظم ڪريو، ۽ سڀ ڪجهه جيڪو اهم آهي ان تي نظر رکو.",
    "getStarted": "شروع ڪريو",
    "next": "اڳيون",
    "firstReminderTitle": "پنهنجو پهريون ياد ڏياريندڙ ٺاهيو!",
    "firstReminderHint": "ڪوشش ڪريو ڪجهه اهڙو لکڻ:",
    "firstReminderExample": "مون کي سڀاڻي 9 وڳي پاڻي پيئڻ ياد ڏياريو",
    "gotIt": "سمجهيو!",
    "notifRationaleTitle": "وقت تي رهو",
    "notifRationaleBody": "FishMemory کي وقت تي ياد ڏيارڻ لاءِ اطلاعن جي ضرورت آهي. توهان کي صرف انهن ياد ڏياريندڙن لاءِ اطلاع ملندي جيڪي توهان ٺاهيو ٿا.",
    "notifRationaleAllow": "اطلاعات فعال ڪريو",
    "notifRationaleLater": "ممڪن آهي بعد ۾",
    "swipeHint": "جلدي عمل لاءِ ساڄي طرف سوائپ ڪريو →",
    "calendarDragHint": "وڌائڻ لاءِ ڇڪيو ↕"
  }
}
